import ApiService from 'api-client/ApiService'
// import Bugsnag from 'utils/bugsnag'
import config from 'app-config'
import type { VmhaConfig, VmhaConfigBody } from 'openstack/components/infrastructure/clusters/model'
import { RetryVMHARequest, RetryVMHAResponse, VMHAStatusDetails } from './model'

class HaMgr extends ApiService {
  public getClassName() {
    return 'haMgr'
  }

  protected async getEndpoint() {
    return Promise.resolve(config.apiHost)
  }

  get baseUrl(): string {
    return '/hamgr/v1'
  }

  getVhmaForAllClusters = async (clusterList: string[]): Promise<VMHAStatusDetails[]> => {
    if (!clusterList?.length) {
      return []
    }

    const queryParams = new URLSearchParams()
    clusterList.forEach((cluster) => {
      queryParams.append('clusterlist', cluster)
    })

    return this.client.basicGet<VMHAStatusDetails[]>({
      url: `${this.baseUrl}/ha?${queryParams.toString()}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getVhmaForAllClusters',
      },
    })
  }

  getVMHAStatusForCluster = async (clusterId) => {
    return this.client.basicGet<{ response: VMHAStatusDetails }>({
      url: `${this.baseUrl}/ha/${clusterId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getVMHAStatusForCluster',
      },
    })
  }

  getHaConfig = async (aggregateId: string) => {
    return this.client.basicGet({
      url: `${this.baseUrl}/ha/${aggregateId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getHaConfig',
      },
    })
  }

  enableHa = async (aggregateId) => {
    const body = {}
    return this.client.basicPut({
      url: `${this.baseUrl}/ha/${aggregateId}/enable`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'enableHa',
      },
    })
  }

  disableHa = async (aggregateId) => {
    const body = {}
    return this.client.basicPut({
      url: `${this.baseUrl}/ha/${aggregateId}/disable`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'disableHa',
      },
    })
  }

  // HM-FR-001: GET /hamgr/v1/vmha/config/{clusterName} — fetch current VMHA config
  getVmhaConfig = async (clusterName: string): Promise<VmhaConfig> => {
    return this.client.basicGet<VmhaConfig>({
      url: `${this.baseUrl}/vmha/config/${clusterName}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getVmhaConfig',
      },
    })
  }

  // HM-FR-002: POST /hamgr/v1/vmha/config/{clusterName} — set evacuation mode and/or NFS path
  updateVmhaConfig = async (clusterName: string, body: VmhaConfigBody): Promise<void> => {
    return this.client.basicPost({
      url: `${this.baseUrl}/vmha/config/${clusterName}`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'updateVmhaConfig',
      },
    })
  }

  retryVMHA = async (body: RetryVMHARequest): Promise<RetryVMHAResponse> => {
    return this.client.basicPost({
      url: `${this.baseUrl}/vmha/retry_evacuation`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'retryVMHA',
      },
    })
  }
}

export default HaMgr
